<script setup>
import { defineProps } from "vue"
import ValidateSkillsWeb from "./Web/ValidateSkillsWeb.vue"
import ValidateSkillsMobile from "./Mobile/ValidateSkillsMobile.vue"
import NotificationBell from "./NotificationBell.vue"

const props = defineProps({
  ratingSkillsModal: {
    default: Object,
    type: Object
  },
  validate: {
    default: Object,
    type: Object
  },
  rating: {
    default: Object,
    type: Object
  },
  userStore: {
    type: Object,
    default: Object
  },
  isLowerThanMobile: {
    type: Boolean,
    default: false
  },
  isMobile: {
    type: Boolean,
    default: false
  },
  refresh: {
    type: Boolean,
    default: false
  },
})

</script>

<template>
  <div>
    <div class="tab-container" v-if="props.userStore.User.permissions.is_admin">
      <div class="tab" :class="{'tab-active': !validate.validationWithCertification.value && !validate.validationToTransfer.value}" @click="validate.ToggleValidationWithoutCertification()">
        <span>PEDIDOS COMUNS</span>
        <notification-bell :count="props.userStore.CountValidations.without_certification" icon="bell" tooltip="Pedidos que tem por publicar"/>
        <notification-bell :count="props.userStore.CountMessages.validation_message_count" icon="envelope" tooltip="Mensagens não vistas"/>
      </div>
      <div class="tab" :class="{'tab-active': validate.validationWithCertification.value && !validate.validationToTransfer.value}" @click="validate.ToggleValidationWithCertification()">
        <span>PEDIDOS COM CERTIFICADO</span>
        <notification-bell :count="props.userStore.CountValidations.with_certification" icon="bell" tooltip="Pedidos que tem por publicar"/>
        <notification-bell :count="props.userStore.CountMessages.validation_with_certificate_message_count" icon="envelope" tooltip="Mensagens não vistas"/>
      </div>
      <div class="tab" :class="{'tab-active': validate.validationToTransfer.value}" @click="validate.ToggleValidationToTransfer()">
        <span>TRANSFERIR</span>
        <notification-bell :count="props.userStore.CountValidations.without_validator" icon="bell" tooltip="Pedidos que tem para transferir para outro validador"/>
      </div>
    </div>

    <div class="page-container">
      <component
        :is="props.validate.isMobile.value || props.validate.isLowerThanMobile.value ? ValidateSkillsMobile : ValidateSkillsWeb"
        :validate-data="props.validate"
        :rating-data="props.rating"
        :rating-skills-modal="props.ratingSkillsModal"
      />
    </div>
  </div>
</template>

<style scoped>

  .div-validate-list {
    width: 100%;
    margin: 0 auto;
  }

  .div-admin-sort {
    display: flex; 
    gap: 10px;
    align-items: center; 
  }

  .div-radios {
    display: flex;
    justify-content: space-between;
  }

  .div-radios div {
    display:flex; 
    gap: 15px; 
    align-items: center;
  }

  .div-radios div input {
    transform: scale(1.3);
  }

  .tab {
    display: flex;
    justify-content: center;
  }
  
  .tab div:nth-child(3) {
    margin-left: 20px;
  }

  .tab-container {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #06071452;
  }

  @media screen and (max-width: 700px) {
    .div-admin-filter {
      font-size: .85em;
    }

    .div-admin-filter {
      gap: 5px;
    }

    .tab-container {
      width: 100%;
    }
  }
</style>
